import { NumberCell } from "components/common/dataGrid";
import { MaterialPhysics } from "src/store/api/generatedApi";
import { calculateLiquidPriceInclElectricity } from "./utils";
import { useElectricalEnergyPrice } from "hooks/useElectricalEnergyPrice";

interface CellProps {
  specificPrice: number | null;
  materialPhysics?: MaterialPhysics;
}

export const LiquidPriceIncludingElectricityCell = ({
  specificPrice,
  materialPhysics,
}: CellProps) => {
  const electricalEnergyPrice = useElectricalEnergyPrice();

  if (
    !materialPhysics ||
    specificPrice === null ||
    electricalEnergyPrice === null
  ) {
    return <NumberCell value={null} decimalPlaces={2} />;
  }
  const totalPrice = calculateLiquidPriceInclElectricity(
    specificPrice,
    materialPhysics,
    electricalEnergyPrice
  );

  return <NumberCell value={totalPrice} decimalPlaces={2} />;
};
